const originalFetch = window.fetch;
export let isFirstCallPending = true;

window.fetch = async function(
  input: RequestInfo | URL,
  init?: RequestInit,
): Promise<Response> {
  if (!isFirstCallPending) {
    return originalFetch(input, init);
  }

  try {
    const response = await originalFetch(input, init);
    if (response.ok) {
      isFirstCallPending = false;
      return response;
    }
  } catch (error) {
    // Ignore error, will retry
  }

  // First call failed or errored, retry after delay
  await new Promise(resolve => setTimeout(resolve, 1000));
  isFirstCallPending = false;
  return originalFetch(input, init);
};
